import SystemValueList from "../../../../components/SystemValue/SystemValueList";

const COLUMNS = [
  { header: "Name", render: (s) => s.name || "—" },
];

const SpecializationList = ({ specializations, onEdit, onDelete }) => (
  <SystemValueList
    items={specializations}
    columns={COLUMNS}
    onEdit={onEdit}
    onDelete={onDelete}
    emptyMessage="No specializations added yet."
  />
);

export default SpecializationList;
